console.log("Feature Detection Engine Loaded");

function detectRequestedFeatures(message){

    message = message.toLowerCase();

    const detectedFeatures = [];

    for(const feature in FEATURE_KEYWORDS){

        const keywords = FEATURE_KEYWORDS[feature];

        for(const keyword of keywords){

            if(message.includes(keyword)){

                detectedFeatures.push(feature);

                break;

            }

        }

    }

    return detectedFeatures;
}

function filterProductsByFeatures(products, features){

    if(!features || !features.length){

        return products;

    }

    return products.filter(product => {

        const productText = (

            (product.title || "") + " " +
            (product.product_type || "") + " " +
            (product.body_html || "") + " " +
            (product.tags || []).join(" ")

        ).toLowerCase();

        return features.every(feature => {

            const keywords = FEATURE_KEYWORDS[feature];

            if(!keywords){

                return false;

            }

            return keywords.some(keyword =>
                productText.includes(keyword.toLowerCase())
            );

        });

    });

}

function filterProductsByFeaturesAndBudget(products, features, budget){

    // First apply feature filtering

    let filtered = filterProductsByFeatures(
        products,
        features
    );

    console.log(
        "After Feature Filter:",
        filtered.length
    );

    // Then apply budget filtering

    if(budget){

        filtered = filterProductsByBudget(
            filtered,
            budget
        );

    }

    console.log(
        "After Budget Filter:",
        filtered.length
    );

    return filtered;

}